import { Route } from "react-router-dom";
import { routes } from "@src/appV2/redesign/utils/routes";
import { Suspense } from "react";
import { FallbackLoader } from "./components/lazyLoad";

import { loadLazily } from "./utils/loadLazily";
import { useInitializeMonitoring } from "./hooks";
import { ShiftBoardPage } from "./appV2/ShiftBoard/Page";

const WorkplaceSignUp = loadLazily(() =>
  import("./containers/workplaceSignUp/WorkplaceSignUp").then((module) => ({
    default: module.WorkplaceSignUp,
  }))
);

interface GuestProps {
  path: string[];
}

export function Guest(_props: GuestProps) {
  useInitializeMonitoring();

  return (
    <Suspense fallback={<FallbackLoader />}>
      <Route
        exact
        path={[routes.workplaceGetAccess, routes.workplaceReferrals]}
        component={WorkplaceSignUp}
      />
      <Route exact path={routes.shiftBoard} component={ShiftBoardPage} />
    </Suspense>
  );
}
